module.exports = __webpack_public_path__ + "static/media/slider-right.ca42b437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/slider-right.svg
// module id = 319
// module chunks = 0